import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`A shipping method tax amount can be set if the cart has the `}<inlineCode parentName="p">{`ExternalAmount`}</inlineCode>{` `}<a parentName="p" {...{
          "href": "/api/../api/projects/carts#taxmode"
        }}>{`TaxMode`}</a>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setShippingMethodTaxAmount"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`externalTaxAmount`}</inlineCode>{` - `}<a parentName="li" {...{
            "href": "/api/../api/projects/carts#externaltaxamountdraft"
          }}>{`ExternalTaxAmountDraft`}</a>{` - Optional`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      